module.exports = __webpack_public_path__ + "static/media/attr_copay.a1ceeeac.svg";